module.exports = __webpack_public_path__ + "static/img/132_TO8_1823.dee5205.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/132_TO8_1823.jpg
// module id = hOnY
// module chunks = 0